// src/router/index.js
import {createRouter, createWebHistory} from 'vue-router';
import Home from '@/views/Home.vue';
import Users from '@/views/Users.vue';
import Sites from '@/views/Sites.vue';
import Reports from '@/views/Reports.vue';
import Prompts from '@/views/Prompts.vue';
import Unauthorized from '@/views/Unauthorized.vue';
import Login from '@/views/Login.vue';
import authService from '@/services/auth';
import { useHospitalsStore } from "@/store/hospitals";

const routes = [
    {path: '/', name: 'Home', component: Home},
    {path: '/users', name: 'Users', component: Users},
    {path: '/sites', name: 'Sites', component: Sites},
    {path: '/reports', name: 'Reports', component: Reports},
    {path: '/prompts', name: 'Prompts', component: Prompts},
    {path: '/login', name: 'Login', component: Login},
    {path: '/unauthorized', name: 'Unauthorized', component: Unauthorized,},
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// Global navigation guard
router.beforeEach((to, from, next) => {
    const publicPages = ['/login/', '/unauthorized'];
    const authRequired = !publicPages.includes(to.path);
    const isAuthenticated = authService.isAuthenticated();

    if (authRequired) {
        // Not authenticated, initiate login
        if( !isAuthenticated ) {
            authService.signIn();
        } else {
            // make sure we're loading hospitals
            const hospitalsStore = useHospitalsStore();
            if (hospitalsStore.hospitals.length === 0 && !hospitalsStore.isLoading) {
                hospitalsStore.fetchHospitals();
            }
            next();
        }
    } else {
        next();
    }
});


export default router;
